<sub-header [includeContextHelp]="false" [isModal]="true" [windowHash]=windowHash>
</sub-header>
<p-scrollPanel [style]="{width: '100%', height: '50vh'}" styleClass="custombar1 ">
  <div class="container-fluid" *ngIf="isLoaded()">
    <div class="row">
      <div class="col-12 m-l-sm m-t-sm alert alert-info">
        <span> <i aria-hidden="true" class="fas fa-1-5x fa-info-circle m-r-md"></i> {{ 'General.user' | translate }}:
          [{{this.user.identifier}}] {{this.user.person.name}} {{this.user.person.surname}}
          {{this.user.person.lastName}}</span>
      </div>
      <div class="col-12 alert alert-info" *ngIf="passNew && strength">
        <span [ngStyle]="{'color': (strength === 'good') ? 'green' :
            (strength === 'medium') ? 'orange' :
            (strength === 'weak') ? 'yellow' :
            'crimson'}">{{ ('LoginView.' + strength) | translate }}</span>
      </div>
      <div class="col-12">
        <label class="login-label">{{ 'LoginView.newPassword' | translate }}</label>
      </div>
      <div class="col-12">
        <input pInput id="passNew" name="passNew" [(ngModel)]="passNew" autocomplete="new-password" type="password"
          [ngModelOptions]="{ standalone: true }" tabindex="2" (keyup)="getPasswordStrength($event)"
          class="col-10 pl-0" />
      </div>
      <div class="col-12">
        <label>{{ 'LoginView.passwordConfirm' | translate }} </label>
      </div>
      <div class="col-12">
        <input pInput id="passConfirm" name="passConfirm" [(ngModel)]="passConfirm" autocomplete="new-password"
          type="password" [ngModelOptions]="{ standalone: true }" tabindex="2" class="col-10 pl-0" />
      </div>
      <div class="col-12 m-l-sm m-t-sm alert {{(passNew && passNew === passConfirm) ? 'alert-info' : 'alert-danger'}}"
        *ngIf="passNew && passConfirm && !(passNew === passConfirm)">
        <span> <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'LoginView.notTheSame' |
          translate }}</span>
      </div>
    </div>
  </div>
</p-scrollPanel>